import { SupportDetailsComponent } from './components/support-details/support-details.component';
import { SupportOverviewCtrl } from './support-overview.controller';

export default angular
  .module('nv.support-overview', ['nv.components.tooltip', 'nv.shared.services'])
  .component('supportDetails', SupportDetailsComponent)
  .controller('SupportOverviewCtrl', SupportOverviewCtrl).name;
